// This file can be replaced during build by using the `fileReplacements` array.
// The list of file replacements can be found in `angular.json`.

import {KeycloakConfig} from 'keycloak-angular';

/*
const keycloakConfig: KeycloakConfig =
{
  url: 'https://sso-dev.scanntech.com/auth',
  realm: 'emision-cfe',
  clientId: 'emision-cfe',
  credentials:
    {
      secret: '513b3a56-7533-4ed1-8b27-b1f557aaf878'
    }
};
*/

const keycloakConfig: KeycloakConfig =
  {
    url: 'https://sso.scanntech.com/auth',
    realm: 'analytics',
    clientId: 'efacturaweb-externo',
    credentials:
      {
        secret: '770e353b-a95f-4537-9fe4-44432acc3e6f'
      }
  };

export const environment =
  {
    production: true,
    apiBaseUrl: 'https://efacturaweb.scanntech.com/products.emisioncfe.rest.server/emisioncfe',
    keycloak: keycloakConfig,
    logoutUrl: 'https://efacturaweb.scanntech.com/',
    baseUrl: 'https://efacturaweb.scanntech.com/'
  };

// export const environment =
//   {
//     production: true,
//     apiBaseUrl: 'https://test.efacturaweb.scanntech.com/products.emisioncfe.rest.server/emisioncfe',
//     keycloak: keycloakConfig,
//     logoutUrl: 'https://test.efacturaweb.scanntech.com/',
//     baseUrl: 'https://test.efacturaweb.scanntech.com/'
//   };
